import styled from 'styled-components';

const PathBlockContainerStyled = styled.section`
  border-radius: ${props => (props.roundWin ? '10px' : '0')};
  box-shadow: ${props =>
    props.roundWin ? '1vmin 1vmin 0 rgba(0,0,0,0.15)' : 'none'};
  display: grid;
  grid-gap: ${props =>
    props.roundWin ? '0' : props.theme.blockContainer.gapSmall};
  max-height: ${props => props.theme.blockContainer.maxHeightSM};
  max-width: ${props => props.theme.blockContainer.maxWidthSM};
  overflow: hidden;
  opacity: ${props => (props.started ? '1' : '0.5')};
  transition: grid-gap ${props => props.theme.blockContainer.transition}
      ${props => props.theme.transition.easeOut},
    opacity ${props => props.theme.blockContainer.transition}
      ${props => props.theme.transition.easeOut},
    border-radius ${props => props.theme.transition.duration}
      ${props => props.theme.transition.easeOut},
    box-shadow ${props => props.theme.transition.duration}
      ${props => props.theme.transition.easeOut};
  transition-delay: ${props => (props.started ? '0s' : '0s, 2s, 0s, 0s')};

  @media screen and (min-width: ${props => props.theme.breakpoints.xl}) {
    grid-gap: ${props =>
      props.roundWin ? '0' : props.theme.blockContainer.gap};
    max-height: calc(
      ${props => props.theme.pageWrap.height} -
        ${props => props.theme.pageWrap.reduceHeightLG}
    );
  }

  /* max-width for block container (on medium screens) */
  @media screen and (min-width: ${props => props.theme.breakpoints.md}) {
    max-height: ${props => props.theme.blockContainer.maxHeightMD};
    max-width: ${props => props.theme.blockContainer.maxWidthMD};
  }

  /* min-max-width for block container (on large screens) */
  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    max-height: ${props => props.theme.blockContainer.maxHeightLG};
    max-width: ${props => props.theme.blockContainer.maxWidthLG};
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
  }

  /* max-width for block container (on x-large screens) */
  @media screen and (min-width: ${props => props.theme.breakpoints.xl}) {
    max-height: ${props => props.theme.blockContainer.maxHeightXL};
    max-width: ${props => props.theme.blockContainer.maxWidthXL};
  }

  /* max-width for block container (on xx-large screens) */
  @media screen and (min-width: ${props => props.theme.breakpoints.xxl}) {
    max-height: ${props => props.theme.blockContainer.maxHeightXXL};
    max-width: ${props => props.theme.blockContainer.maxWidthXXL};
  }

  /* Portrait (max-width) */
  @media screen and (max-width: ${props => props.theme.breakpoints.lg}) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr 1fr;
  }

  /* Landscape */
  @media screen and (min-width: ${props => props.theme.breakpoints.lg + 1}) {
    /* min-max-width for block container (on large screens) */
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
  }
`;

export default PathBlockContainerStyled;



// WEBPACK FOOTER //
// ./src/components/molecules/PathBlockContainer/PathBlockContainer.styled.js